class SorellaCustomStorefront extends HTMLElement {}

const sorellaCartMutation = (task) => {
  const header = document.querySelector('sorella-custom-header');
  return header?.runCartMutation ? header.runCartMutation(task) : task();
};

const sorellaCartErrorMessage = async (response, fallback = 'This item could not be added.') => {
  const payload = await response.json().catch(() => ({}));
  const raw = payload.description || payload.message
    || (typeof payload.errors === 'string' ? payload.errors : '')
    || Object.values(payload.errors || {}).flat().filter(Boolean).join(' ')
    || fallback;
  const message = String(raw).replace(/^Error:\s*/i, '').trim();
  if (/sold\s*out|out\s*of\s*stock|not\s*enough\s*in\s*stock|unavailable|cannot\s*be\s*sold/i.test(message)) {
    return 'This size is sold out or no longer available. Please choose another size.';
  }
  return message || fallback;
};

const updateStoryControls = (carousel, index) => {
  const slides = [...carousel.querySelectorAll('[data-story-slide]')];
  carousel.querySelectorAll('[data-story-dot]').forEach((dot, dotIndex) => dotIndex === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
  const previous = carousel.querySelector('[data-story-prev]');
  const next = carousel.querySelector('[data-story-next]');
  if (previous) previous.disabled = index === 0;
  if (next) next.disabled = index === slides.length - 1;
};

document.addEventListener('click', async (event) => {
  const storyVariantOpen = event.target.closest('[data-open-story-variants]');
  if (storyVariantOpen) {
    event.preventDefault();
    const dialog = document.getElementById(storyVariantOpen.getAttribute('aria-controls'));
    if (dialog?.showModal) {
      dialog.showModal();
      dialog.querySelector('[data-story-variant-option]:checked')?.focus();
    }
    return;
  }
  const reviewMore = event.target.closest('[data-review-more]');
  if (reviewMore) {
    const section = reviewMore.closest('[data-review-list]');
    const pageSize = Number(section?.dataset.reviewPageSize || 10);
    const hiddenReviews = [...(section?.querySelectorAll('[data-review-card][hidden]') || [])];
    const revealed = hiddenReviews.slice(0, pageSize);
    revealed.forEach((review) => review.hidden = false);
    if (revealed[0]) {
      revealed[0].setAttribute('tabindex', '-1');
      revealed[0].focus({ preventScroll:true });
      revealed[0].scrollIntoView({ behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'nearest' });
    }
    const remaining = hiddenReviews.length - revealed.length;
    const allReviews = [...(section?.querySelectorAll('[data-review-card]') || [])];
    const visibleReviews = allReviews.filter((review) => !review.hidden).length;
    const showing = section?.querySelector('[data-review-showing]');
    if (showing) showing.textContent = `Showing ${visibleReviews} of ${allReviews.length} reviews`;
    if (remaining <= 0) reviewMore.hidden = true;
    return;
  }
  const dialogTrigger = event.target.closest('[data-open-intensity],[data-open-family]');
  if (dialogTrigger) {
    const dialog = document.querySelector(dialogTrigger.hasAttribute('data-open-intensity') ? '[data-intensity-dialog]' : '[data-family-dialog]');
    if (dialog?.showModal) dialog.showModal();
    return;
  }
  const dialogClose = event.target.closest('[data-close-dialog]');
  if (dialogClose) {
    dialogClose.closest('dialog')?.close();
    return;
  }
  const offer = event.target.closest('[data-catalog-offer]');
  if (offer) {
    if (event.target.closest('[data-offer-close]')) offer.hidden = true;
    else document.querySelector('sorella-custom-header')?.openBenefits?.();
    return;
  }
  const filterToggle = event.target.closest('[data-filter-toggle]');
  if (filterToggle) {
    const drawer = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;
    const requestedGroup = filterToggle.dataset.filterFocus;
    const isDrawerControl = drawer.contains(filterToggle);
    const shouldOpen = requestedGroup ? true : (isDrawerControl ? false : drawer.hidden);
    drawer.hidden = !shouldOpen;
    document.documentElement.classList.toggle('dcatalog-filter-open', shouldOpen);
    document.querySelectorAll('[data-filter-toggle]').forEach((button) => button.setAttribute('aria-expanded', String(shouldOpen)));
    if (shouldOpen && requestedGroup) {
      const group = drawer.querySelector(`[data-filter-group="${CSS.escape(requestedGroup)}"]`);
      drawer.querySelectorAll('details').forEach((details) => { details.open = details.contains(group); });
      group?.closest('details')?.scrollIntoView({ block: 'nearest' });
      (group?.querySelector('input,a,button') || group)?.focus();
    } else if (shouldOpen) drawer.querySelector('button, input, select')?.focus();
    return;
  }
  const storyControl = event.target.closest('[data-story-prev],[data-story-next],[data-story-dot]');
  if (storyControl) {
    const carousel = storyControl.closest('[data-story-carousel]');
    const slides = [...carousel.querySelectorAll('[data-story-slide]')];
    const track = carousel.querySelector('[data-story-track]');
    const isSwipeLayout = window.matchMedia('(max-width: 767px)').matches;
    const current = isSwipeLayout ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : Math.max(0, slides.findIndex((slide) => !slide.hidden));
    const requested = storyControl.dataset.storyDot == null ? current + (storyControl.hasAttribute('data-story-prev') ? -1 : 1) : Number(storyControl.dataset.storyDot);
    const next = Math.max(0, Math.min(slides.length - 1, requested));
    if (isSwipeLayout) {
      slides.forEach((slide) => slide.removeAttribute('hidden'));
      track.scrollTo({ left: next * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    } else slides.forEach((slide, index) => { slide.hidden = index !== next; });
    updateStoryControls(carousel, next);
    return;
  }
  const scrollButton = event.target.closest('[data-scroll-next],[data-scroll-prev]');
  if (scrollButton) {
    const rail = scrollButton.closest('.dhome__rail')?.querySelector('[data-product-rail]');
    if (rail) rail.scrollBy({ left: rail.clientWidth * (scrollButton.hasAttribute('data-scroll-prev') ? -0.8 : 0.8), behavior: 'smooth' });
    return;
  }
  const add = event.target.closest('[data-add-to-cart]');
  if (!add) return;
  event.preventDefault();
  if (add.classList.contains('is-loading')) return;
  add.classList.add('is-loading');
  add.disabled = true;
  const status = add.closest('dialog')?.querySelector('[data-add-error]') || add.closest('.dhome__product,.dcatalog-card,.dpdp-layer-card,.sweather-card,.sugc-product')?.querySelector('[data-add-error]');
  if (status) status.textContent = '';
  const label = add.querySelector('span');
  const original = label?.textContent;
  let added = false;
  if (label) label.textContent = 'ADDING…';
  try {
    const response = await sorellaCartMutation(() => fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:Number(add.dataset.variantId),quantity:1}]}) }));
    if (!response.ok) {
      throw new Error(await sorellaCartErrorMessage(response));
    }
    added = true;
    if (label) label.textContent = original;
    add.classList.remove('is-loading');
    add.disabled = false;
    const header = document.querySelector('sorella-custom-header');
    await header?.loadCart?.();
    add.closest('dialog')?.close();
    header?.openDrawer?.('cart');
    document.dispatchEvent(new CustomEvent('sorella:cart:updated'));
  } catch (error) {
    if (label) label.textContent = added ? original : 'TRY AGAIN';
    if (status) status.textContent = error.message;
    if (!added) setTimeout(() => { if (label?.isConnected) label.textContent = original; }, 1800);
  } finally {
    if (added && label) label.textContent = original;
    add.classList.remove('is-loading');
    add.disabled = false;
  }
});

const normalizeSorellaFormat = (value) => {
  const format = String(value || '').toLowerCase();
  if (format.includes('gold edition') || format.includes('gold-edition')) return 'gold-edition';
  if (format.includes('oil')) return 'oil';
  if (format.includes('musk-tolla') || format.includes('musk tolla')) return 'musk-tolla-8ml';
  if (format.includes('5ml') && format.includes('musk')) return '5ml-musk-tester';
  if (format.includes('30ml')) return '30ml';
  if (format.includes('50ml')) return '50ml';
  if (format.includes('5ml')) return '5ml-perfume-tester';
  return format;
};

const mediaMatchesFormat = (element, format) => {
  const role = element?.dataset.mediaRole || 'gallery';
  return !['primary', 'key-notes'].includes(role) || normalizeSorellaFormat(element.dataset.mediaFormat) === normalizeSorellaFormat(format);
};

const syncProductGallery = (format, focusFirst = false) => {
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery || !format) return;
  const normalizedFormat = normalizeSorellaFormat(format);
  gallery.dataset.selectedFormat = normalizedFormat;
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  slides.forEach((slide) => {
    slide.hidden = !mediaMatchesFormat(slide, normalizedFormat);
    slide.classList.remove('dpdp-gallery__item--hero');
  });
  const visibleSlides = slides.filter((slide) => !slide.hidden);
  const heroSlide = visibleSlides.find((slide) => slide.dataset.mediaRole === 'primary' && normalizeSorellaFormat(slide.dataset.mediaFormat) === normalizedFormat) || visibleSlides[0];
  heroSlide?.classList.add('dpdp-gallery__item--hero');
  const dots = [...document.querySelectorAll('[data-gallery-dots] [data-gallery-dot]')];
  dots.forEach((dot) => {
    dot.hidden = !mediaMatchesFormat(dot, normalizedFormat);
    dot.removeAttribute('aria-current');
  });
  const heroDot = dots.find((dot) => !dot.hidden && dot.dataset.mediaId === heroSlide?.dataset.mediaId) || dots.find((dot) => !dot.hidden);
  heroDot?.setAttribute('aria-current', 'true');
  if (focusFirst && heroSlide) gallery.scrollTo({ left: heroSlide.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
};

const syncProductVariant = (form, variant, options = {}) => {
  const price = form?.closest('.dpdp-buybox')?.querySelector('[data-product-price]');
  if (price && variant.dataset.price) price.textContent = variant.dataset.price;
  const add = form?.querySelector('.dpdp-form__add span');
  if (add && variant.dataset.price) add.textContent = `Add to cart · ${variant.dataset.price}`;
  const formId = form?.getAttribute('id') || '';
  const sticky = document.querySelector(`[data-sticky-purchase][data-form-id="${CSS.escape(formId)}"]`);
  const stickySelect = sticky?.querySelector('[data-sticky-variant]');
  const stickyButton = sticky?.querySelector('[data-sticky-add]');
  if (stickySelect) stickySelect.value = variant.value;
  sticky?.querySelectorAll('[data-sticky-icon-for]').forEach((icon) => { icon.hidden = icon.dataset.stickyIconFor !== variant.value; });
  if (stickyButton) {
    stickyButton.disabled = variant.disabled;
    const stickyLabel = stickyButton.querySelector('span') || stickyButton;
    stickyLabel.textContent = variant.disabled ? 'Sold out' : `Add to cart · ${variant.dataset.price}`;
  }
  syncProductGallery(variant.dataset.sourceFormat, options.focusGallery);
  if (variant.dataset.variantUrl && options.updateUrl !== false) history.replaceState({}, '', variant.dataset.variantUrl);
};

document.addEventListener('change', (event) => {
  const storyVariant = event.target.closest('[data-story-variant-option]');
  if (storyVariant) {
    const dialog = storyVariant.closest('[data-story-variant-dialog]');
    const add = dialog?.querySelector('[data-story-variant-add]');
    const price = dialog?.querySelector('[data-story-variant-price]');
    if (add) add.dataset.variantId = storyVariant.value;
    if (price) price.textContent = storyVariant.dataset.price || '';
    return;
  }
  const cardVariant = event.target.closest('[data-card-variant]');
  if (cardVariant) {
    const card = cardVariant.closest('[data-product-card]');
    const add = card?.querySelector('[data-add-to-cart]');
    const price = card?.querySelector('[data-card-price]');
    const image = card?.querySelector('.dcatalog-card__media img');
    const links = card?.querySelectorAll('a[href*="/products/"]') || [];
    if (add) add.dataset.variantId = cardVariant.value;
    if (price && cardVariant.dataset.price) price.textContent = cardVariant.dataset.price;
    if (image && cardVariant.dataset.imageUrl) {
      image.src = cardVariant.dataset.imageUrl;
      image.srcset = '';
    }
    links.forEach((link) => { if (cardVariant.dataset.variantUrl) link.href = cardVariant.dataset.variantUrl; });
    return;
  }
  const stickySelect = event.target.closest('[data-sticky-variant]');
  if (stickySelect) {
    const sticky = stickySelect.closest('[data-sticky-purchase]');
    const form = document.getElementById(sticky?.dataset.formId || '');
    const variant = form?.querySelector(`[name="id"][value="${CSS.escape(stickySelect.value)}"]`);
    if (variant) {
      variant.checked = true;
      variant.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }
  const variant = event.target.closest('[data-variant-option]');
  if (!variant) return;
  syncProductVariant(variant.closest('[data-product-form]'), variant, { focusGallery: true });
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('.dpdp-form__add');
  const status = form.querySelector('[data-product-error]');
  if (!button || button.disabled) return;
  const formId = form.getAttribute('id') || '';
  const stickyButton = document.querySelector(`[data-sticky-purchase][data-form-id="${CSS.escape(formId)}"] [data-sticky-add]`);
  const controls = [button, stickyButton].filter(Boolean).map((control) => ({ control, label:control.querySelector('span') || control, original:(control.querySelector('span') || control).textContent }));
  controls.forEach(({control,label}) => { control.disabled = true; control.classList.add('is-loading'); label.textContent = 'Adding…'; });
  let added = false;
  if (status) status.textContent = '';
  try {
    const response = await sorellaCartMutation(() => fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) }));
    if (!response.ok) throw new Error(await sorellaCartErrorMessage(response));
    const payload = await response.json().catch(() => ({}));
    added = true;
    controls.forEach(({control,label,original}) => { label.textContent = original; control.disabled = false; control.classList.remove('is-loading'); });
    const header = document.querySelector('sorella-custom-header');
    await header?.loadCart?.();
    header?.openDrawer?.('cart');
    document.dispatchEvent(new CustomEvent('sorella:cart:updated', { detail: payload }));
  } catch (error) {
    if (status) status.textContent = error.message;
    controls.forEach(({label,original}) => { label.textContent = added ? original : 'Try again'; });
    if (!added) setTimeout(() => controls.forEach(({label,original}) => { if (label.isConnected) label.textContent = original; }), 1800);
  } finally {
    controls.forEach(({control,label,original}) => { if (added) label.textContent = original; control.disabled = false; control.classList.remove('is-loading'); });
  }
});

document.addEventListener('keydown', (event) => {
  const drawer = document.querySelector('[data-filter-drawer]:not([hidden])');
  if (drawer && event.key === 'Tab') {
    const focusable = [...drawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),summary')].filter((item) => item.offsetParent !== null);
    if (focusable.length) {
      const first = focusable[0]; const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }
  if (event.key !== 'Escape' || !drawer) return;
  drawer.hidden = true;
  document.documentElement.classList.remove('dcatalog-filter-open');
  document.querySelector('[data-filter-toggle]')?.focus();
});

document.addEventListener('scroll', (event) => {
  const rail = event.target.closest?.('[data-product-rail]');
  if (!rail) return;
  const section = rail.closest('.dhome__rail');
  const previous = section?.querySelector('[data-scroll-prev]');
  const next = section?.querySelector('[data-scroll-next]');
  if (previous) previous.disabled = rail.scrollLeft <= 1;
  if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
}, true);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const selected = form.querySelector('[data-variant-option]:checked') || form.querySelector('[data-variant-option]');
    if (selected) syncProductVariant(form, selected, { updateUrl: false });
    const formId = form.getAttribute('id') || '';
    const sticky = document.querySelector(`[data-sticky-purchase][data-form-id="${CSS.escape(formId)}"]`);
    if (!sticky) return;
    const updateSticky = () => {
      const formRect = form.getBoundingClientRect();
      sticky.hidden = formRect.bottom >= 0;
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  });
  document.querySelectorAll('dialog.dpdp-info-dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      if (outside) dialog.close();
    });
  });
  document.querySelectorAll('[data-personality-scroll]').forEach((scroller) => {
    const sticky = scroller.querySelector('.dpdp-personality__sticky');
    const scenes = [...scroller.querySelectorAll('[data-personality-scene]')];
    const count = scroller.querySelector('[data-personality-count]');
    if (!sticky || !scenes.length) return;
    let frame;
    const update = () => {
      frame = null;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rect = scroller.getBoundingClientRect();
      const distance = Math.max(1, rect.height - window.innerHeight);
      const progress = Math.max(0, Math.min(1, -rect.top / distance));
      const entry = reduced ? 1 : Math.max(0, Math.min(1, progress * scenes.length));
      const active = reduced ? 0 : Math.min(scenes.length - 1, Math.floor(progress * scenes.length));
      sticky.style.setProperty('--personality-shift', `${(1 - entry) * 62}%`);
      sticky.style.setProperty('--personality-scale', String(.52 + entry * .48));
      sticky.style.setProperty('--personality-radius', `${(1 - entry) * 32}px`);
      sticky.style.setProperty('--personality-progress', String(Math.max(.01, progress)));
      scenes.forEach((scene, index) => scene.classList.toggle('is-active', index === active));
      if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(scenes.length).padStart(2, '0')}`;
    };
    const requestUpdate = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  });
  document.querySelectorAll('[data-story-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-story-track]');
    const slides = [...carousel.querySelectorAll('[data-story-slide]')];
    if (!track || !slides.length) return;
    if (window.matchMedia('(max-width: 767px)').matches) slides.forEach((slide) => slide.removeAttribute('hidden'));
    let frame;
    track.addEventListener('scroll', () => {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => updateStoryControls(carousel, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    }, { passive: true });
    updateStoryControls(carousel, 0);
  });
  document.querySelectorAll('[data-product-rail]').forEach((rail) => {
    const section = rail.closest('.dhome__rail');
    const previous = section?.querySelector('[data-scroll-prev]');
    const next = section?.querySelector('[data-scroll-next]');
    if (previous) previous.disabled = true;
    if (next) next.disabled = rail.scrollWidth <= rail.clientWidth + 1;
  });
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const dots = [...(gallery.closest('.dpdp-gallery-wrap')?.querySelectorAll('[data-gallery-dot]') || [])];
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    dots.forEach((dot) => dot.addEventListener('click', () => slides.find((slide) => slide.dataset.mediaId === dot.dataset.mediaId)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })));
    gallery.addEventListener('scroll', () => {
      const visibleSlides = slides.filter((slide) => !slide.hidden);
      const active = visibleSlides.reduce((closest, slide) => Math.abs(slide.offsetLeft - gallery.scrollLeft) < Math.abs(closest.offsetLeft - gallery.scrollLeft) ? slide : closest, visibleSlides[0]);
      dots.forEach((dot) => dot.dataset.mediaId === active?.dataset.mediaId ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
    }, { passive: true });
    syncProductGallery(gallery.dataset.selectedFormat, false);
  });
});
